module.exports = __webpack_public_path__ + "img/target.8ef8353d.png";